import React, { useState } from 'react';
import { ChevronDown, ChevronRight, Settings as SettingsIcon } from 'lucide-react';
import CaseTime from './CaseTime';
import CaseSettings from './CaseSettings';

// Tab-consolidation: Time & Billing = time entries/invoices/payments (CaseTime)
// + the billing/prepaid configuration (CaseSettings) that used to live in its
// own Settings tab. Billing config now has a single home.
const CaseBillingTab = ({ caseId, onRefresh }) => {
  const [showConfig, setShowConfig] = useState(false);

  return (
    <div>
      <CaseTime caseId={caseId} onRefresh={onRefresh} />

      <div className="mt-6 border-t border-virgo-navy-600 pt-4">
        <button
          onClick={() => setShowConfig((v) => !v)}
          className="flex items-center gap-2 text-virgo-gold-400 hover:text-virgo-gold-300 font-semibold"
        >
          {showConfig ? <ChevronDown size={18} /> : <ChevronRight size={18} />}
          <SettingsIcon size={16} /> Billing settings &amp; prepaid
        </button>
        {showConfig && (
          <div className="mt-4">
            <CaseSettings caseId={caseId} />
          </div>
        )}
      </div>
    </div>
  );
};

export default CaseBillingTab;
